import { useEffect } from "react";

import { MSG } from "../../../constants/msg";
import { ROLES } from "../../../constants/roles";
import { useUserAuth0Verify } from "../../../hooks/useUser";

import { isNotEmpty, useForm } from "@mantine/form";
import { Button, Grid, Paper, TextInput, Title } from "@mantine/core";
import RadioCard from "../../../components/ui/Form/RadioCard";
import { FaArrowRight } from "react-icons/fa";
import { RegisterFormValues, RegisterProps } from "types/module/User/Onboarding";

const Register: React.FC<RegisterProps> = ({
  user,
  isSubmitting,
  setIsSubmitting,
  setOnboardStep,
  restartSteps,
}) => {
  const form = useForm<RegisterFormValues>({
    initialValues: {
      firstName: user.name?.split(" ")[0] ?? "",
      lastName: user.name?.split(" ")[1] ?? "",
      role: null,
    },
    validate: {
      firstName: isNotEmpty(MSG.VALIDATE.REQUIRED("First Name")),
      lastName: isNotEmpty(MSG.VALIDATE.REQUIRED("Last Name")),
      role: isNotEmpty(MSG.VALIDATE.REQUIRED("Role")),
    },
  });

  const {
    mutate: userUserAuth0VerifySendMutate,
    data: userUserAuth0VerifySendData,
    isSuccess: userUserAuth0VerifySendSuccess,
    isError: userUserAuth0VerifySendError,
  } = useUserAuth0Verify();

  const handleDetailSubmit = (form: RegisterFormValues) => {
    // @ts-ignore todo: for hooks ts migration
    userUserAuth0VerifySendMutate({
      email: user.email,
      firstName: form.firstName,
      lastName: form.lastName,
      role: form.role,
    });

    setIsSubmitting(true);
  };

  useEffect(() => {
    if (userUserAuth0VerifySendSuccess || userUserAuth0VerifySendError) {
      if (userUserAuth0VerifySendSuccess && userUserAuth0VerifySendData) {
        form.reset();
        if (userUserAuth0VerifySendData.data?.isUser) {
          setOnboardStep("REGISTER_EXIST");
        } else {
          setOnboardStep("REGISTER_NEW");
        }
      }
      setIsSubmitting(false);
    }
  }, [userUserAuth0VerifySendSuccess, userUserAuth0VerifySendError]);

  return (
    <>
      <Title ta="center" c="black">
        Please select a permission profile.
      </Title>
      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        <form onSubmit={form.onSubmit((values: RegisterFormValues) => handleDetailSubmit(values))}>
          <Grid>
            <Grid.Col>
              <TextInput label="Email" value={user.email} disabled={true} />
            </Grid.Col>
            <Grid.Col span={6}>
              <TextInput
                key="firstName"
                label="First Name"
                placeholder="Enter First Name"
                disabled={isSubmitting}
                {...form.getInputProps("firstName")}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <TextInput
                key="lastName"
                label="Last Name"
                placeholder="Enter Last Name"
                disabled={isSubmitting}
                {...form.getInputProps("lastName")}
              />
            </Grid.Col>
            <Grid.Col>
              <RadioCard
                label="User Role"
                description="Which of the permission profiles below best matches the user's role?"
                data={ROLES}
                error={form.errors.role}
                {...form.getInputProps("role")}
              />
            </Grid.Col>
            <Grid.Col span={{ md: 8 }}>
              <Button
                type="submit"
                loading={isSubmitting}
                disabled={isSubmitting || !form.values.role?.trim()}
                rightSection={<FaArrowRight size={14} />}
                fullWidth
              >
                Proceed
              </Button>
            </Grid.Col>
            <Grid.Col span={{ md: 4 }}>
              <Button
                variant="default"
                onClick={restartSteps}
                disabled={isSubmitting}
                fullWidth
              >
                Cancel
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </Paper>
    </>
  );
};

export default Register;
